import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {Stack} from "@mui/material";
import {changeWorkQueue} from "../WorkQueue/workQueueSlice";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {changeWork} from "./workSlice";
import {changeContract} from "../Contract/contractSlice";
import {changeWorkIssuance} from "../WorkIssuance/workIssuanceSlice";



export default function WorkTabs(props) {
    const [workViewTabValue, setWorkViewTabValue] = React.useState(0);


    const dispatchData = useDispatch();


    const selectorTabIndex = useSelector((state) => state.workSlc.value.workTabsIndex);

    const expandContracts = useSelector((state) => state.workQueueSlc.value.contractExpand);
    const expandSeries = useSelector((state) => state.workQueueSlc.value.contractExpandSeriesId);
    const expandProduct = useSelector((state) => state.workQueueSlc.value.contractExpandProductId);

    const expandTitleId = expandSeries === null ? expandProduct : expandSeries;

const expandMultiSingle = useSelector(
    (state) => state.workQueueSlc.value.contractExpandSeriesId) === null ? "single" : "multi";



    const handleContractExpand = () => {
        console.log("handleContractExpand");
        if (expandContracts === true) {
            setWorkViewTabValue(2);

            dispatchData(changeWorkQueue({propertyDropdownTitleId: expandTitleId,
                propertyDropdownMultiSingle: expandMultiSingle, workQueueCGridRefresh: true}));
            console.log("propertyDropdownTitleId modified to equal expandTitleId ", expandTitleId);
        }
    };
    useEffect(() => {
        console.log("contract expand triggered");
        handleContractExpand();
    }, [useSelector((state) => state.workQueueSlc.value.contractExpand)===true]);



    const handleChange = (event, newValue) => {
        setWorkViewTabValue(newValue);
        if(newValue === 0){
            dispatchData(changeWork({workTabsIndex: 0,
                searchScreenVisible: true,
                workDashboardVisible: false,
                workContractVisible: false,
                workIssuanceVisible: false}));
            dispatchData(changeWorkQueue({selectedContractId: 0, selectedContractName: null, workQueueFinalize: false
                , bigAddButtonDisplay: false}));}
        if(newValue === 1){
            dispatchData(changeWork({workTabsIndex: 1,
                searchScreenVisible: false,
                workDashboardVisible: true,
                workContractVisible: false,
                workIssuanceVisible: false
            }));
            dispatchData(changeContract({contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                residualsTabsVisible: false, participationsTabsVisible: false,royaltiesTabsVisible: false, module: 'Dashboards',contractGridAPI: "Dashboards"}));
            console.log("Dashboards Selected");
            console.log("contractGridAPI = Dashboards");
            dispatchData(changeWorkQueue({selectedContractId: 0, selectedContractName: null,workQueueFinalize: false,
                propertyDropdownTitleId: null, bigAddButtonDisplay: false}));}
        if(newValue === 2){
            dispatchData(changeWork({workTabsIndex: 2,
                searchScreenVisible: false,
                workDashboardVisible: false,
                workContractVisible: true,
                workIssuanceVisible: false}));
            dispatchData(changeWorkQueue({selectedContractId: 0, selectedContractName: null,propertyDropdownListState:true,
                workQueueFinalize: false, propertyDropdownTitleId: null, bigAddButtonDisplay: true}));
            dispatchData(changeWorkIssuance({
                calcSearchProductId: 0,
                versionMode: null,
                versionStatusId: null,
                versionStatusName: null,
                periodEndDate: null,
                testScenarioNumber : null,
                testScenarioName : null,
                testScenarioPropertyId : null,
                testScenarioPropertyName : null,
            }));
            }
        if(newValue === 3) {
            dispatchData(changeWork({workTabsIndex: 3,
                searchScreenVisible: false,
                workDashboardVisible: false,
                workContractVisible: false,
                workIssuanceVisible: true}));
            dispatchData(changeWorkQueue({selectedContractId: 0, selectedContractName: null,propertyDropdownListState:false,
                workQueueFinalize: false, propertyDropdownTitleId: null, bigAddButtonDisplay: false}));
            dispatchData(changeWorkIssuance({calcTabState: true, payTabState: false, owedGridState: true, obligationGridState: false,
                offsetsGridState: false,paymentGridState: false,fringeGridState: false,taxGridState: false,expenseGridState: false,
                requestGridState: false, confirmationGridState: false,clearData: true, fetchProductId: 0}));
        }
    };

    return (
        <Stack direction="row" spacing={2}>

            <Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>
                <Tabs value={selectorTabIndex} defaultValue={selectorTabIndex}


                  onChange={handleChange} centered>
                <Tab label="Welcome"
                    title="Visualizations of system data"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />

                <Tab label="Dashboards"
                     title="User dashboards of system status"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Contracts"   title="Contract data in original context"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>
                <Tab label="Issuance"   title="Calculation and payment data"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>

            </Tabs>
        </Box>

        </Stack>
    );
}
